export const studyVideoLog = (position) => {
  window.log && window.log('yx_center', 'workbench_studyvideo', `{"position":"${position}"}`);
};
